Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var consts_iconMap = require('../consts/iconMap.js');

var useStatusBadgeIcon = function (view, size, customIcons) {
    var iconsMap = consts_iconMap.ICON_MAP;
    // transform initial icons map
    if (customIcons) {
        iconsMap = Object.keys(consts_iconMap.ICON_MAP).reduce(function (acc, current) {
            var _a;
            return (tslib.__assign(tslib.__assign({}, acc), (_a = {},
                _a[current] = tslib.__assign(tslib.__assign({}, consts_iconMap.ICON_MAP[current]), customIcons[current]),
                _a)));
        }, {});
    }
    var Icon = iconsMap[view][size];
    return { Icon: Icon };
};

exports.useStatusBadgeIcon = useStatusBadgeIcon;
